import React, { useEffect, useRef, useState } from 'react';
import Cargotruck from "../../../../assets/images/cargo-truck.png";

import Planing from "../../../../assets/images/planning.png";

import ActivityComments from '../../../../Components/common/ActivityComments.js';
import ImageUpload from '../../../../Components/common/ImageUpload.js';
import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import Shipment from './inc/Shipment.js';
import ManageOffers from './inc/ManageOffers.js';
import Attachments from './inc/Attachments.js';
import Status from './inc/Status.js';

import Shipmentn from "../../../../assets/images/shipment_n.png"; 
import Shipmentw from "../../../../assets/images/shipment_w.png";
import Statusn from "../../../../assets/images/status.png";
import Statusw from "../../../../assets/images/status_w.png";
import Managen from "../../../../assets/images/manage.png";
import Managew from "../../../../assets/images/manage_w.png";

import { faArrowLeft, faBolt, faChevronDown, faGear, faPaperclip, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, Modal, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { withRFSToken } from '../../../../Services/axios.js';
import { TRUCKORDERDETAILS, DELAWB } from '../../../../Utils/conts';
import { toast } from 'react-toastify';

const TruckOrderDetails = () => {
    const fileInputRef = useRef(null);
    const isMounted = useRef(false);
    let storedData = localStorage.getItem('TODetails');
    if (storedData) {
        storedData = JSON.parse(storedData)
    }
    const [selectedRowData, setSelectedRowData] = useState({});


    const [selectedButton, setSelectedButton] = useState(storedData.tab || 'shipment');
    // const [editData, setEditData] = useState({});



    const loadDetails = async (number, setdata) => {
        try {
            const res = await withRFSToken.post(TRUCKORDERDETAILS, { truck_orders_id: number })
                .then(function (res) {
                    const innerData = res;
                    if (res.data.response_code == 200) {
                        setSelectedRowData(res.data.response_data);
                        if (setdata) {
                            localStorage.removeItem('TODetails');
                            const storageData = { ...selectedRowData, tab: 'manage' };
                            localStorage.setItem('TODetails', JSON.stringify(storageData));
                        }
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    // useEffect(() => {
    //     if (isMounted.current) return;

    //     isMounted.current = true;
    // }, []);

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    useEffect(() => {
        if (isMounted.current) return;
        loadDetails(storedData.truck_orders_id);
        isMounted.current = true;
    }, []);

    const [show, setShow] = useState(false);
    const [addEdit, setAddEdit] = useState('');
    const [editmodalData, setEditModalData] = useState();



    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const handleOrderTruck = () => {
        localStorage.removeItem('OT');
        const sendData = {
            truck_type: 'B',
            bookingTruck_type: 'E',
            existing_date: selectedRowData.date
        }
        localStorage.setItem('OT', JSON.stringify(sendData));
        window.location.href = '/OrderTruck'
    }

    const [notArea, setNotArea] = useState();
    const [rowId, setRowId] = useState();

    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState();
    const handleModalClose = () => { setShowModal(false); setModalData(); };
    const handleModalOpen = (area, item) => {
        setNotArea(area);
        if (area === 'G') {
            setRowId(item);
        }
        setShowModal(true);

    };
    // const handleConfirmation = (confirm) => {
    //     if (confirm) {
    //         if (notArea === 'G') {
    //             handleDeleteRow();
    //         }
    //         setShowModal(false);
    //     } else {
    //         setModalData();
    //     }
    // };

    // const handleDeleteRow = async () => {
    //     try {
    //         const res = await withRFSToken.post(DELAWB, { awb_id: rowId })
    //             .then(function (res) {
    //                 const innerData = res.data;
    //                 if (res.data.response_code === 200) {
    //                     // fetchPalletList();
    //                     setTimeout(() => {
    //                         setIsLoading(false);
    //                         window.$(gridRef.current).jqxGrid('updatebounddata');
    //                     }, 1);
    //                 }

    //             });

    //     } catch (error) {
    //         console.error('Error sending request:', error);
    //     }
    // }

    const handleShow = (button) => {
        setSelectedButton(button);
    };
    const handleClose = () => {
        setShow(false);
    };

    // const reloadGridData = () => {
    //     setTimeout(() => {
    //         setIsLoading(false);
    //         window.$(gridRef.current).jqxGrid('updatebounddata');
    //     }, 1);
    // }


    return (
        <div className="">{console.log('ddd', addEdit)}
            <Header logo_url='/TruckOrder' />
            <div className="schedule">
                <LeftMenu />
                <div className='main-panel'>
                    <Link to={storedData.back ?? '/TruckOrder'} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                    <div className='maindiv'>
                        <div className='SecondDiv  mt-3'>
                            <div className='girddtals_header'>
                                <h3>
                                    {selectedRowData?.truck_no}
                                    <span className='left_rqst'>
                                        {
                                            selectedRowData?.Status == 'r' ? (
                                                <label className="bookingstatus requested">Requested</label>
                                            ) : selectedRowData?.Status == 'o' ? (
                                                <label className="bookingstatus offered">Offer Received</label>
                                            ) : selectedRowData?.Status == 'b' ? (
                                                <label className="bookingstatus booked">Booked</label>
                                            ) : ''
                                        }
                                    </span>
                                </h3>
                                <div className='d-flex actbtn justify-content-between'>
                                    <div className='d-flex actbtn'>

                                        <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                        {/* <Dropdown>
                                            <Dropdown.Toggle variant="light" id="dropdown-basic">
                                                <FontAwesomeIcon icon={faBolt} /> Action
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item href="#/action-1">Edit Bookingtruck</Dropdown.Item>
                                                <Dropdown.Item href="#/action-2">Manage Shipments</Dropdown.Item>
                                                <Dropdown.Item href="#" onClick={handleOrderTruck}>Order Truck</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown> */}

                                    </div>

                                </div>
                            </div>
                            {selectedRowData.coload?.map((co, index) => (
                                <div key={`${index}_col`} className='order_duplicate'>
                                    <p>Bookingtruck No - <span>{co.bookingtruck_no}</span></p>
                                    <div className='d-flex justify-content-between rabord'>
                                        <div className='firstbrd'>
                                            <p>Boardpoint</p>
                                            <span>{co.board_point}</span>
                                        </div>
                                        <div className='middlebrd'>
                                            <p>DEP : {selectedRowData.departure_date}  {selectedRowData.departure_time}</p>
                                            <p><img src={Cargotruck} /></p>
                                            <p>ARR : {selectedRowData.arrival_date}  {selectedRowData.arrival_time}</p>
                                        </div>
                                        <div className='lastbrd'>
                                            <p>Offpoint</p>
                                            <span>{co.off_point}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {/* <div className='d-flex justify-content-between rabord'>
                                <div className='firstbrd'>
                                    <p>Boardpoint</p>
                                    <span>{selectedRowData?.Boardpoint}</span>
                                </div>
                                <div className='middlebrd'>
                                    <p>{selectedRowData?.Date}</p>
                                    <p><img src={Cargotruck} /></p>
                                    <p>{selectedRowData?.Time}</p>
                                </div>
                                <div className='lastbrd'>
                                    <p>Offpoint</p>
                                    <span>{selectedRowData?.Offpoint}</span>
                                </div>
                            </div> */}
                            <div>
                                {/* <h3>Operational Trucks</h3> */}
                                <div className='opttrauck mb-3'>
                                    <Accordion defaultActiveKey="0" flush>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Truck Information</Accordion.Header>
                                            <Accordion.Body>
                                                <ul className='truck_info'>
                                                    <li><span>Type :</span> <span>Booking Truck</span></li>
                                                    <li><span>Departure Date/ Time  :</span> <span>{selectedRowData.departure_date} {selectedRowData.departure_time}</span></li>
                                                    <li><span>Arival Date / Time  :</span> <span>{selectedRowData.arrival_date} {selectedRowData.arrival_time}</span></li>
                                                    {/* <li><span>Date and Time  :</span> <span>{selectedRowData.departure_date} {selectedRowData.departure_time}</span></li> */}
                                                    {/* <li><span>Type of work :</span> <span>{selectedRowData.booking_type == 'E' ? 'Export' : 'Import'}</span></li> */}
                                                    <li><span>Truck Load  :</span> <span> {selectedRowData.service_type == 'F' ? 'FLT' : selectedRowData.service_type_value - 'LTL'}</span></li>
                                                    <li><span>Temperature  :</span> <span>{selectedRowData.temperature == '18-21' ? '18-21' : 'NO'}</span></li>
                                                    <li><span>Number of Drivers  :</span> <span>{selectedRowData.driver_number}</span></li>
                                                    <li><span>Truck Material  :</span> <span>{selectedRowData.truck_material === 'HC' ? 'Hard Cover' : selectedRowData.truck_material === 'CS' ? 'Curtain Slider' : selectedRowData.truck_material === 'FT' ? 'Flatbed Trailer' : 'Unknown'}</span></li>
                                                    <li><span>ADR Required  :</span> <span>{selectedRowData.adr_required == '1' ? 'YES' : 'NO'}</span></li>
                                                    <li><span>Boardpoint Address  :</span> <span>{selectedRowData.board_point_station_address}</span></li>
                                                    <li><span>Offpoint Address  :</span> <span>{selectedRowData.off_point_station_address}</span></li>
                                                    <li><span>Min Truck Height(cm)  :</span> <span>{selectedRowData.truck_height} cm</span></li>
                                                    <li><span>Rollerbed :</span> <span>{selectedRowData.rollerbed === 'Y' ? 'YES' : 'NO'}</span></li>
                                                    <li><span>Remarks :</span> <span>{selectedRowData.remarks}</span></li>
                                                </ul>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            </div>

                            <div className='mb-3'>
                                <div className='d-flex justify-content-between align-items-center mb-2'>
                                    <h3 className='mb-0'>Truck Request</h3>
                                    {/* <h4 className='manag_offer'> Manage Offers <span>3 </span></h4> */}
                                </div>
                                {selectedRowData.truck_order_requests?.map((req, index) => (
                                    <div key={index}
                                        className={
                                            `d-flex justify-content-between align-items-center
                                                ${req.request_status == 'Requested' ? 'order_rqst'
                                                : req.request_status == 'Rejected' ? 'order_reject'
                                                    : req.request_status == 'Booked' ? 'order_book' : 'offerbg'}`
                                        }
                                    >
                                        <div><span>Trucker Name</span><h4>{req.trucker_name}</h4></div>
                                        <div className='received'><span>{req.request_status}</span></div>
                                        <div className='offer_price'>{req?.currency_type} {req?.response_amount}</div>
                                    </div>
                                ))}
                            </div>

                            <ImageUpload
                                ref={imageUploadRef}
                                attachable_type={"truck_order"}
                                attachable_id={selectedRowData?.truck_orders_id}
                                attachment_no={selectedRowData?.truck_no}
                                attachments={selectedRowData?.attachments}
                                onDeleteSuccess={() => loadDetails(selectedRowData?.truck_orders_id)}
                            />
                            <ActivityComments
                                commentable_type={"truck_order"}
                                commentable_id={selectedRowData?.truck_orders_id}
                                allactivities={selectedRowData?.activities}
                                onReloadDetails={loadDetails}
                            />

                        </div>
                        <div className='w-100 mt-3'>
                            <div className='d-flex truck_ord_ship'>
                                <button className={selectedButton === 'shipment' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleShow('shipment')}>
                                    <span> <img src={selectedButton === 'shipment' ? Shipmentw : Shipmentn} /> Shipment</span>
                                </button>
                                <button className={selectedButton === 'manage' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleShow('manage')}>
                                    <span> <img src={selectedButton === 'manage' ? Managew : Managen} />  Manage Offers </span>
                                </button>
                                <button className={selectedButton === 'attach' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleShow('attach')}>
                                    <span> <img src={selectedButton === 'attach' ? Shipmentw : Shipmentn} />  Attachments </span>
                                </button>
                                {/* <button className={selectedButton === 'status' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleShow('status')}>
                                    <span> <img src={selectedButton === 'status' ? Statusw : Statusn} />  Status</span>
                                </button> */}
                            </div>
                            <div className='d-flex'>
                                <div className='mvownload'></div>
                            </div>
                            <div className={selectedButton === 'attach'? 'mt-3 h-95' : 'mt-3 nestedtabs rounded h-95 position-relative'}>
                                {selectedButton === 'shipment' && <Shipment />}
                                {selectedButton === 'manage' && <ManageOffers data={selectedRowData} reload={() => loadDetails(storedData.truck_orders_id, true)} />}
                                {selectedButton === 'status' && <Status />}
                                {selectedButton === 'attach' && <Attachments fData={selectedRowData} onLoad={() => loadDetails(storedData.truck_orders_id, true)} />}
                                {/* {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>} */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Modal show={show} onHide={handleClose} centered className='addfrom awb_modal'>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    {addEdit === 'A' ?
                        <AddAWB
                            isModal={true}
                            closeModal={handleClose}
                            assignData={selectedRowData}
                            reloadGrid={reloadGridData}
                        />
                        : addEdit === 'E' ?
                            <AddAWB
                                isModalEdit={true}
                                closeModal={handleClose}
                                assignData={editmodalData}
                            // reloadGrid={reloadGridData}
                            />

                            :
                            <AssignAWB
                                isModal={true}
                                closeModal={handleClose}
                                // assignData={editmodalData}
                                reloadGrid={reloadGridData}
                            />
                    }

                </Modal.Body>
            </Modal> */}
            {/* <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>All changes will be destroyed.</h3>
                    <p>If you proceed with the change, all data in this section will be removed.
                        Are you sure you want to continue?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={() => handleConfirmation(true)}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal> */}
        </div>
    )
}

export default TruckOrderDetails